module.exports = __webpack_public_path__ + "assets/media/smsbig.88e1bc20.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/smsbig.svg
// module id = 311
// module chunks = 0